export const DefaultNuggetFilters = {
    'showAnswered': false,
    'textContent': '',
    'userName': '',
    'showTipeee': true,
    'showYoutube': true,
    'showOther': true,
    'showAllNuggets': false,
}